import React from "react";
import { Link } from "react-router-dom";
import bgImage from "../assets/images/bg-01.jpg";
import about1 from "../assets/images/about-01.jpg";
import about2 from "../assets/images/about-02.jpg";
import FeaturesSection from "../components/FeaturesSection";

const About = () => {
  return (
    <>
      {/* ================= Hero Section ================= */}
      <section
        className="position-relative d-flex align-items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,.65), rgba(0,0,0,.65)), url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "500px",
        }}
      >
        <div className="container text-center text-white">
          <span className="badge bg-warning text-dark px-3 py-2 rounded-pill mb-3">
            Trusted • Secure • Premium Shopping Experience
          </span>

          <h1 className="display-2 fw-bold mb-4">
            About <span className="text-warning">Glamira</span>
          </h1>

          <p
            className="mx-auto fs-5"
            style={{ maxWidth: "750px", opacity: 0.9 }}
          >
            We believe shopping should be effortless, enjoyable, and built on
            trust. From premium products to exceptional customer support, every
            experience is designed with you in mind.
          </p>

          <Link
              to="/shop"
            className="btn btn-warning btn-lg rounded-pill px-5 mt-4 fw-semibold"
          >
            Explore Collection
          </Link>
        </div>
      </section>

      <FeaturesSection />

      {/* ================= Statistics ================= */}

      <section className="py-5 bg-white border-bottom">
        <div className="container">
          <div className="row text-center">

            <div className="col-md-3 col-6 mb-4">
              <h2 className="fw-bold text-primary display-5">50K+</h2>
              <p className="text-muted">Happy Customers</p>
            </div>

            <div className="col-md-3 col-6 mb-4">
              <h2 className="fw-bold text-primary display-5">15K+</h2>
              <p className="text-muted">Premium Products</p>
            </div>

            <div className="col-md-3 col-6 mb-4">
              <h2 className="fw-bold text-primary display-5">99%</h2>
              <p className="text-muted">Customer Satisfaction</p>
            </div>

            <div className="col-md-3 col-6 mb-4">
              <h2 className="fw-bold text-primary display-5">24/7</h2>
              <p className="text-muted">Customer Support</p>
            </div>

          </div>
        </div>
      </section>

      {/* ================= About ================= */}

      <section className="py-5 bg-light">
        <div className="container">

          {/* Story */}

          <div className="row align-items-center mb-5">

            <div className="col-lg-6">

              <span className="text-primary fw-bold text-uppercase">
                Our Story
              </span>

              <h2 className="display-5 fw-bold mt-2 mb-4">
                More Than an Online Store
              </h2>

              <p className="text-muted fs-5">
                Glamira was created with one mission—to redefine online shopping
                by combining quality, affordability, and trust in one platform.
                We understand that every purchase matters, which is why we focus
                on delivering products that customers genuinely love.
              </p>

              <p className="text-muted">
                From carefully curated collections to secure checkout and timely
                delivery, every detail is built to provide a seamless shopping
                experience. Our commitment extends beyond products—we strive to
                create lasting relationships with our customers through honesty,
                transparency, and outstanding service.
              </p>

              <div className="row mt-4">

                <div className="col-sm-6 mb-3">
                  <div className="bg-white rounded-4 shadow-sm p-3 h-100">
                    <h5>🚚 Fast Delivery</h5>
                    <small className="text-muted">
                      Reliable shipping with real-time tracking.
                    </small>
                  </div>
                </div>

                <div className="col-sm-6 mb-3">
                  <div className="bg-white rounded-4 shadow-sm p-3 h-100">
                    <h5>🔒 Safe Payments</h5>
                    <small className="text-muted">
                      Secure transactions protected by modern technology.
                    </small>
                  </div>
                </div>

              </div>

            </div>

            <div className="col-lg-6 mt-5 mt-lg-0 text-center">
              <img
                src={about1}
                className="img-fluid rounded-4 shadow-lg"
                alt="About"
              />
            </div>

          </div>

          {/* Mission */}

          <div className="row align-items-center py-5">

            <div className="col-lg-6 order-lg-2">

              <span className="text-primary fw-bold text-uppercase">
                Our Mission
              </span>

              <h2 className="display-5 fw-bold mt-2 mb-4">
                Delivering Happiness Through Shopping
              </h2>

              <p className="text-muted fs-5">
                Our mission is to create an eCommerce destination where customers
                can shop confidently, discover premium products, and enjoy an
                effortless buying experience.
              </p>

              <p className="text-muted">
                We continuously improve our technology, expand our collections,
                and enhance customer support to ensure every interaction exceeds
                expectations.
              </p>

              <div className="bg-white shadow-sm rounded-4 p-4 border-start border-5 border-primary mt-4">
                <p className="fst-italic mb-2">
                  “Every order is an opportunity to create trust and delight.”
                </p>

                <strong>— Team Glamira</strong>
              </div>

            </div>

            <div className="col-lg-6 order-lg-1 text-center mb-4 mb-lg-0">
              <img
                src={about2}
                className="img-fluid rounded-4 shadow-lg"
                alt="Mission"
              />
            </div>

          </div>

          {/* Vision */}

          <div className="py-5 text-center">

            <span className="text-primary fw-bold text-uppercase">
              Our Vision
            </span>

            <h2 className="display-5 fw-bold mt-2 mb-4">
              Building the Future of Online Shopping
            </h2>

            <p
              className="mx-auto text-muted fs-5"
              style={{ maxWidth: "850px" }}
            >
              We aspire to become one of the most trusted and customer-centric
              eCommerce destinations by combining innovation, premium quality,
              transparency, and exceptional service. Our vision is to make every
              shopping journey inspiring, secure, and memorable.
            </p>

          </div>

          {/* Why Choose */}

          <div className="py-5">

            <div className="text-center mb-5">
              <h2 className="display-5 fw-bold">
                Why Choose Glamira?
              </h2>

              <p className="text-muted fs-5">
                Everything we do is focused on providing an exceptional shopping
                experience.
              </p>
            </div>

            <div className="row g-4">

              {[
                {
                  icon: "🛍️",
                  title: "Easy Shopping",
                  text: "Simple navigation and hassle-free checkout designed for everyone.",
                },
                {
                  icon: "🔐",
                  title: "Secure Payments",
                  text: "Advanced payment security keeps every transaction protected.",
                },
                {
                  icon: "⭐",
                  title: "Premium Quality",
                  text: "Only carefully selected products that meet high standards.",
                },
                {
                  icon: "🎧",
                  title: "Dedicated Support",
                  text: "Friendly customer support before and after every purchase.",
                },
              ].map((item, index) => (
                <div className="col-lg-3 col-md-6" key={index}>
                  <div
                    className="card border-0 shadow-sm h-100 p-4 text-center"
                    style={{
                      borderRadius: "20px",
                      transition: ".3s",
                    }}
                  >
                    <div style={{ fontSize: "50px" }}>{item.icon}</div>

                    <h5 className="mt-3 fw-bold">{item.title}</h5>

                    <p className="text-muted">
                      {item.text}
                    </p>
                  </div>
                </div>
              ))}

            </div>

          </div>

          {/* Values */}

          <div className="py-5">

            <div className="row text-center">

              <div className="col-md-4 mb-4">
                <div className="bg-white shadow rounded-4 p-4 h-100">
                  <h3>💙</h3>
                  <h5>Customer First</h5>
                  <p className="text-muted">
                    Every decision starts with improving customer satisfaction.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="bg-white shadow rounded-4 p-4 h-100">
                  <h3>🚀</h3>
                  <h5>Innovation</h5>
                  <p className="text-muted">
                    We continuously evolve to provide smarter shopping
                    experiences.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="bg-white shadow rounded-4 p-4 h-100">
                  <h3>🤝</h3>
                  <h5>Trust</h5>
                  <p className="text-muted">
                    Transparency and reliability are the foundation of our
                    business.
                  </p>
                </div>
              </div>

            </div>

          </div>

          {/* CTA */}

          <div
            className="rounded-4 py-5 text-center px-4"
            style={{
              background:
                "linear-gradient(135deg,#2563eb,#4f46e5,#7c3aed)",
            }}
          >

            <h2 className="display-5 fw-bold text-white">
              Start Your Shopping Journey Today
            </h2>

            <p
              className="text-white mx-auto mt-3 fs-5"
              style={{ maxWidth: "700px", opacity: 0.9 }}
            >
              Join thousands of satisfied customers who trust Glamira for
              quality products, secure payments, and outstanding service.
            </p>

            <a
              href="/shop"
              className="btn btn-warning btn-lg rounded-pill px-5 mt-3 fw-semibold"
            >
              Shop Now →
            </a>

          </div>

        </div>
      </section>
    </>
  );
};

export default About;